<template>
  <div>
    <div>
      <breadcrumb :breadcrumb_link="hellokittyisland_breadcrumb" />
    </div>

    <div class="outterBox">
      <div class="header">
        <!--      <h1 class="overlay">SPECIAL SOUVENIR</h1>-->
        <!--      <img src="@/assets/images/Podohotel/about_headerimage.jpg" />-->
        <div class="headerimage" />
      </div>

      <div class="container contentDesc">
        <div class="title1">
          <div class="titleDesc col-lg-12 text-center">
            <div style="color: #b9b1b1; margin-bottom: 10px">{{ $t('benefit_program_subtitle') }}</div>
          </div>
          <h2>
            <strong>{{ $t('benefit_program_title') }}</strong>
          </h2>
        </div>
      </div>

      <div class="container">
        <div class="hellokittyisland_header row d-flex justify-content-center">
          <!--          <div>-->
          <!--            &lt;!&ndash;          <div class="overlay"><h1>SPECIAL BENEFITS</h1></div>&ndash;&gt;-->
          <!--            <img src="@/assets/images/Podohotel/benefitinfo_headerimage.png" />-->
          <!--          </div>-->
          <!--          <div class="wedding_body_hedaer text-center col-lg-12 mt-5 mb-4">-->
          <!--            <h2><strong>헬로키티 아일랜드</strong></h2>-->
          <!--          </div>-->
          <!--          <div class="col-lg-12 text-center mb-5" style="margin-bottom: 30px">-->
          <!--            <h4 style="color: #b9b1b1">글로벌 캐릭터 헬로키티를 만날 수 있는</h4>-->
          <!--          </div>-->

          <img class="imageStyle" src="@/assets/images/Podohotel/benefitinfo_bodyimage18.jpg" />
        </div>

        <div class="row d-inline-block pt-5 pb-5 p-2">
          <div class="mb-5">
            <div class="mx-5">
              {{ $t('benefit_program_desc') }}
            </div>
          </div>
          <hr />
          <table class="table table-borderless mt-5 mx-auto col-lg-8 col-12">
            <tbody>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td1') }}</td>
                <td>{{ $t('benefit_program_table_td2') }}</td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td3') }}</td>
                <td>{{ $t('benefit_program_table_td4') }}</td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td5') }}</td>
                <td>{{ $t('benefit_program_table_td6') }}</td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td7') }}</td>
                <td>{{ $t('benefit_program_table_td8') }}</td>
              </tr>
              <tr class="d-flex flex-column mb-4">
                <td class="font-weight-bold">{{ $t('benefit_program_table_td9') }}</td>
                <td>
                  <a
                    class="text-dark"
                    style="word-break: break-all"
                    target="_blank"
                    href="http://www.hellokittyisland.co.kr/"
                    >http://www.hellokittyisland.co.kr/</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Breadcrumb from '@/components/Breadcrumb';

export default {
  name: 'Hellokittyisland',
  data() {
    return {
      hellokittyisland_breadcrumb: {
        toplink: 'HOME',
        prevlink: 'SPECIAL OFFERS',
        present: this.$t('breadcrumb'),
      },
      isLang: 0,
    };
  },
  methods: {
    refreshLocale(newVal) {
      if (newVal === 'ko') {
        this.isLang = 0;
      } else if (newVal === 'en') {
        this.isLang = 1;
      } else if (newVal === 'ja') {
        this.isLang = 2;
      } else {
        this.isLang = 0;
      }

      if (this.isLang === 0) {
        this.hellokittyisland_breadcrumb.prevlink = 'SPECIAL OFFERS > 제휴사 혜택 안내';
      } else {
        this.hellokittyisland_breadcrumb.prevlink = 'SPECIAL OFFERS > PARTNERSHIP';
      }

      this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
    },
  },
  watch: {
    '$i18n.locale'(newVal, oldVal) {
      this.refreshLocale(newVal);
    },
  },
  async created() {
    this.refreshLocale(this.$i18n.locale);
  },
  mounted() {
    this.$store.dispatch('Display/changeName', {name: this.$t('breadcrumb')});
  },
  components: {Breadcrumb},
};
</script>

<style scoped lang="scss">
.table h5 {
  margin: 0;
}
.table td {
  padding: 5px;
}

h5 {
  word-break: keep-all;
}

.main-ex-desc {
  vertical-align: bottom;
}

.header {
  position: relative;
  width: 100%;
  padding-top: 0rem;
  > img {
    width: 100%;
  }

  .overlay {
    padding-top: 0rem;
    color: White;
    position: absolute;
    text-align: center;
    z-index: 12;
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    font-weight: lighter;
    letter-spacing: -0.1rem;
  }

  .headerimage {
    display: block;
    width: 100%;
    margin: 0;
    content: url('~@/assets/images/Podohotel/benefitinfo_headerimage.png');
  }
}

.contentDesc {
  padding-top: 3rem;
  padding-bottom: 3rem;
  text-align: center;
}

.outterBox {
}

@media (max-width: 992px) {
  .header {
    display: none;
  }
  .outterBox {
    padding-top: 5rem;
  }

  h2 {
    font-size: 1.5rem !important;
  }

  h3 {
    font-size: 1.3rem !important;
  }

  h4 {
    font-size: 1rem !important;
  }

  h5 {
    line-height: 1.6rem !important;
    font-size: 1rem !important;
  }

  .imageStyle {
    width: 100%;
  }
}
</style>

<i18n>
{
  "ko": {
    "breadcrumb": "헬로키티 아일랜드",
    "benefit_program_subtitle" : "글로벌 캐릭터 헬로키티를 만날 수 있는",
    "benefit_program_title" : "헬로키티 아일랜드",
    "benefit_program_desc" : "글로벌 캐릭터인 헬로키티를 주모델로 한 국내 최대규모의 캐릭터 전문 전시관이자, 최초의 헬로키티 상설전시관입니다. 헬로키티의 역사, 가족, 음악과 공연교육, 전시, 3D영상관, 체험활동, 기획작품 갤러리 등 다채롭고 풍성한 문화 공간이자, 다양한 헬로키티상품을 만날 수 있는 Brand shop, 헬로키티와 향기롭고 따뜻한 Coffee와 Desert를 함께 할 수 있는 헬로키티카페 그리고 아이들에게 꿈과 희망, 창의성을 키워주는 다양한 프로그램이 준비되어 있습니다.",
    "benefit_program_table_td1" : "할인혜택",
    "benefit_program_table_td2" : "투숙객 입장료 10% 할인",
    "benefit_program_table_td3" : "이용방법",
    "benefit_program_table_td4" : "영수증 및 객실 키 제시",
    "benefit_program_table_td5" : "주소",
    "benefit_program_table_td6" : "제주특별자치도 서귀포시 안덕면 한창로 340",
    "benefit_program_table_td7" : "문의번호",
    "benefit_program_table_td8" : "064-792-6114",
    "benefit_program_table_td9" : "웹사이트"
  },
  "en": {
    "breadcrumb": "Hello Kitty Island",
    "benefit_program_subtitle" : "글로벌 캐릭터 헬로키티를 만날 수 있는",
    "benefit_program_title" : "헬로키티 아일랜드",
    "benefit_program_desc" : "글로벌 캐릭터인 헬로키티를 주모델로 한 국내 최대규모의 캐릭터 전문 전시관이자, 최초의 헬로키티 상설전시관입니다. 헬로키티의 역사, 가족, 음악과 공연교육, 전시, 3D영상관, 체험활동, 기획작품 갤러리 등 다채롭고 풍성한 문화 공간이자, 다양한 헬로키티상품을 만날 수 있는 Brand shop, 헬로키티와 향기롭고 따뜻한 Coffee와 Desert를 함께 할 수 있는 헬로키티카페 그리고 아이들에게 꿈과 희망, 창의성을 키워주는 다양한 프로그램이 준비되어 있습니다.",
    "benefit_program_table_td1" : "할인혜택",
    "benefit_program_table_td2" : "투숙객 입장료 10% 할인",
    "benefit_program_table_td3" : "이용방법",
    "benefit_program_table_td4" : "영수증 및 객실 키 제시",
    "benefit_program_table_td5" : "주소",
    "benefit_program_table_td6" : "제주특별자치도 서귀포시 안덕면 한창로 340",
    "benefit_program_table_td7" : "문의번호",
    "benefit_program_table_td8" : "064-792-6114",
    "benefit_program_table_td9" : "웹사이트"
  },
  "ja": {
  }
}
</i18n>
